import { get } from "lodash";
import log from "loglevel";
import * as t from "./types";

export const getAccountReducerResponse = (
  state: any,
  responseType: string
): t.Account => {
  log.info("Getting Account from Store...");
  const value = get(state, `account.response.${responseType}`);
  return value;
};

export const getAccountsReducerResponse = (
  state: any,
  responseType: string
): t.Account[] => {
  log.info("Getting Accounts from Store...");
  const value = get(state, `accounts.response.${responseType}`);
  return value;
};

export const getIsCurrentUserAccountOwnerReducerResponse = (
  state: any,
  responseType: string
): t.CurrentUserAccountOwnerStatus => {
  log.info("Getting CurrentUserAccountOwnerStatus from Store...");
  const value = get(
    state,
    `isCurrentUserAccountOwner.response.${responseType}`
  );
  return value;
};
